import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";

const ProtectedRoute = ({ children }) => {
  const { authToken } = useContext(AuthContext);

  console.log(authToken, "authToken")

  if (!authToken) {
    // Redirect to sign-in if user is not authenticated
    return <Navigate to="/sign-in" replace />;
  }

  return children;
};

export default ProtectedRoute;
